import Vue from "vue";
import RewardComplete from "./src/RewardComplete.vue";

function rewardComplete(bool) {
  const el = document.createElement("div");
  document.body.append(el);
  const vm = new Vue({
    parent: window.app,
    render: h => {
      return h(RewardComplete, {
        props: { value: bool },
        on: {
          closed: () => {
            vm.$el.remove();
            vm.$destroy();
          }
        }
      });
    }
  });
  vm.$mount(el);
}

export { rewardComplete };
